module.exports = __webpack_public_path__ + "img/Pro-tekt-logo-beta.dfcde9bc.png";